import { checkShouldUseMocks } from '@telialt/utils/src/envUtils';
import { MS_URL } from '@telialt/utils/src/microservices';

export const API = {
    NAVIGATION: `${MS_URL}/api/v3/content/layouts`,
    MAINTENANCE: `${MS_URL}/api/v3/content/maintenance`,
    PENDING_DOCUMENTS: `${MS_URL}/api/v3/documents/{segment}/list`,
    B2B_AGREEMENTS_LIST: `/api/v1/{segment}/my/agreements`,
    CUSTOMER: '/api/v1/{segment}/customer',
    SIGNING_IN_PROGRESS_ORDER: `${MS_URL}/api/v3/orders/{segment}/sign-in-progress-orders/exist`,
};

if (checkShouldUseMocks({ shouldUseInTest: true })) {
    API.NAVIGATION = '/api/nav/b2c';
    API.MAINTENANCE = '/api/nav/maintenance';
    API.PENDING_DOCUMENTS = '/api/self-service/documents/list-unsigned';
    API.B2B_AGREEMENTS_LIST = `/api/self-service/mobility/agreements?{segment}`;
    API.CUSTOMER = '/api/customer/settings';
    API.SIGNING_IN_PROGRESS_ORDER = '/api/eshop/sign-in-progress-orders-exist';
}
